import request from '@/utils/request'

export function getAuthInit() {
  return request({
    url: '/api/gcp/auth/init',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/extra.js